@import "src/style/lib";

.news-list-page {
  background: $bjelin-smoke;
}

.news-list-container {
  max-width: 87.5rem;
  margin: 2em auto;
}
